module.exports = __webpack_public_path__ + "static/media/scaling.3393ce23.png";